import { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useSearchParams } from "react-router-dom"
import useProfileData from "../hooks/useProfileData";
import AppHeader from "../Components/Header/AppHeader";
import { urlAccess } from "./routeAccess";
import { jwtDecode } from "jwt-decode";
import { FloatButton } from "antd";
import { IoIosLogOut } from "react-icons/io";
import { checkCookie, deleteCookie } from "../Pages/ReviewPortal/ReviewPortal.helpers";
// import './AppHeader.css';

function ProtectedRoute({ children }) {
  let jwt = localStorage.getItem("JwtToken");
  const { profileData } = useProfileData();
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();

  const source = searchParams.get('source');
  const appraisalEmpId = searchParams.get('EmpId');

  if (source && source === 'mail' && pathname.includes('Appraisal') && appraisalEmpId) {
    const appraisalId = +pathname.slice(-1);
    if (appraisalId === 1 || appraisalId === 2 || appraisalId === 3 || appraisalId === 5) {
      localStorage.setItem('appraisalFormId', appraisalId);
      localStorage.setItem('appraisalEmpId', appraisalEmpId);
      localStorage.setItem('redirectFromMail', true);
    }
  }

  useEffect(() => {
    document.title = "Techlabs";
  }, [])

  if (!jwt) {
    return <Navigate to="/" />
  }

  if (jwt) {
    const decodedToken = jwtDecode(jwt);
    const tokenExpiry = decodedToken.exp * 1000 || 0;
    const currentTimestamp = new Date().getTime();
    if (tokenExpiry < currentTimestamp) {
      localStorage.removeItem("JwtToken");
      return <Navigate to="/" />
    }
  }


  const isAllowed = urlAccess.some(route => {
    (route.route === pathname) &&
      ((typeof profileData?.userRole === "string" && route.accessAllowed.includes(profileData.userRole.toLowerCase())))
    if (route.route === pathname) {
      if (typeof profileData?.userRole === "string") {
        if (route.accessAllowed.includes(profileData.userRole.toLowerCase()) || route.accessAllowed.includes("all")) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  });

  const notAllowedMsg = <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '1rem',
    height: '75vh'
  }}>
    <h1>You are not Allowed to visit this page</h1>
    <Link to={-1}>Back</Link>
  </div>
  return <>
    {
      (pathname === '/Dashboard') ||
        (pathname === '/HrEmployeeList') ||
        (pathname === '/HrEmpTargetList') ||
        (pathname === "/HrEmpTarget") ||
        (pathname === "/Pdfhtml") ? null :
        <div className="sticky-nav">
          <AppHeader data={profileData} />
        </div>
    }
    {/* <div className="sticky-nav">
        <AppHeader data={profileData} />
      </div> */}
    {/* {isAllowed ? children : notAllowedMsg} */}
    {children}
  </>
}

export default ProtectedRoute;
